
import React from "react";
import StaticOptions from "./staticOptions";

export default class StaticFilter extends React.Component{
    constructor(props){
        super(props);
        this.selectedOptions = [];
        this.defaultOptions = props.getStaticOptions ? props.getStaticOptions(props) : props.staticOptions;
        this.options = this.defaultOptions || [];
        this.state={
            searchTerm:""
        }
    }

    doesFilterPass(params){
        let currentValue = this.props.valueGetter(params.node);

        // To be able to filter blank columns
        if(currentValue.length === 0){
            currentValue = "";
        }
        return this.isOptionSelected(currentValue);
    }

    isFilterActive(){
        return this.selectedOptions.length > 0;
    }

    onOptionSelected = (value, checked) => {
       if(checked){
           this.selectedOptions.push(value);
       }else{
           this.selectedOptions = this.selectedOptions.filter(option => option !== value);
       }
       this.forceUpdate(); // we dont have state here so using this to rerender
       this.props.filterChangedCallback();
    }

    isOptionSelected = (value) => {
        if(Array.isArray(value) && value.length > 0){
            return this.selectedOptions.findIndex(option => value.includes(option)) >= 0;
        }
        return this.selectedOptions.findIndex(option => option === value) >= 0;
    }

    onSelectAll = (checked) => {
        if(checked){
            this.options.map(option=>{
                this.selectedOptions.push(option.value)
            });
        }else{
            this.selectedOptions = [];
        }
        this.forceUpdate();
        this.props.filterChangedCallback();
    }

    // set filter state
    setModel(model){
        if(model === null) {
            this.selectedOptions = [];
            this.forceUpdate();
        }
    }

    // retrieve filter state
    getModel(){
        return this.selectedOptions;
    }

    onSearch = (searchValue) => {
        if(searchValue){
            this.options = this.defaultOptions.filter(option=>option.text.toLowerCase().includes(searchValue.toLowerCase()));
        }else{
            this.options = this.defaultOptions || [];
        }
        this.setState({
            searchTerm:searchValue
        });
    }

    render(){
        return(
            <StaticOptions
                options={this.options}
                renderIcon={this.props.renderIcon}
                isOptionSelected={this.isOptionSelected}
                onOptionSelected={this.onOptionSelected}
                onSelectAll={this.onSelectAll}
                onSearch={this.onSearch}
                searchTerm={this.state.searchTerm}
            />
        )
    }
}